import React, { useEffect, useState, useRef } from "react";
import Swiper from "react-id-swiper";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
import "../portraitSlider/portraitSlider.css";
import "swiper/components/lazy/lazy.min.css";
import "./landscapeSlider.css";
import Global from "../../global";
import SectionHeader from "../sectionHeader/sectionHeader";
import { getPlaylist, getAWSUrl, getYoutubePlaylist } from "../api/core";
import SwiperCore, { Navigation, Pagination, Lazy } from "swiper/core";
import Anchor from "../Link/anchor";
import { Link } from "react-router-dom";
import { favourited, favourites, truncate } from "../javascript/function";
import { UserStore } from "../store/store";
import LazyImg from "../lazy/lazy";
import Icon from "../icon/icon";
import { BORDER } from "../../global";
SwiperCore.use([Lazy, Navigation, Pagination]);

const LandscapeSlider = (props) => {
  const mounted = useRef(false);
  const init = { playlist: [] };
  const y_init = { items: [] };
  const [lselem, setLSElem] = useState([]);
  const [lselemItem, setLSItem] = useState([]);
  const [lsplaylist, setLSPlaylist] = useState(
    Global.VCMS === "YouTube" ? y_init : init
  );
  const [loading, isLoading] = useState(true);
  /* eslint-disable no-unused-vars */
  const [error, SetError] = useState(false);
  const [elemlsdisplay, setLSElemDisplay] = useState(true);
  const [desc, setDesc] = useState(false);
  const [news, setNews] = useState(false);
  const [viewlsAll, setViewlsAll] = useState("");
  const [viewlsLink, setviewlsLink] = useState("");
  const currentUser = UserStore.useState((s) => s.user);

  const params = {
    slidesPerView: 2,
    slidesPerGroup: 2,
    slidesPerGroupSkip: 1,
    spaceBetween: 5,
    centeredSlides: false,
    speed: 800,
    loop: false,
    rtl: Global.RTL ? "rtl" : "",
    preloadImages: false,
    observer: true,
    observeParents: true,

    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 5,
        slidesPerGroup: 1,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      400: {
        slidesPerView: 2,
        spaceBetween: 5,
        slidesPerGroup: 2,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      576: {
        slidesPerView: 3,
        spaceBetween: 5,
        slidesPerGroup: 3,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      577: {
        slidesPerView: 2,
        spaceBetween: 5,
        slidesPerGroup: 2,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      720: {
        slidesPerView: 2.5,
        spaceBetween: 5,
        slidesPerGroup: 2,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      900: {
        slidesPerView: 3,
        spaceBetween: 5,
        slidesPerGroup: 3,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 5,
        slidesPerGroup: 3,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      1200: {
        slidesPerView: 3.5,
        spaceBetween: 8,
        slidesPerGroup: 3,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      1300: {
        slidesPerView: 5,
        spaceBetween: 8,
        slidesPerGroup: 5,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
    },
    runCallbacksOnInit: true,
    onInit: (swiper) => {},
  };

  useEffect(() => {
    mounted.current = true;
    const ElemDetail = async () => {
      if (mounted.current) {
        setLSElem(props.tabbed ? props.tabid : props.information);

        setLSElemDisplay(
          props.tabbed
            ? props.tabid.devices[0].itemVisibility
            : props.information.devices[0].itemVisibility
        );
        setLSItem(props.tabbed ? props.tabid.items : props.information.items);

        if (!props.tabbed) {
          if (
            props.information.playlistId !== null &&
            props.information.playlistId !== ""
          ) {
            playlistDetail(
              props.information.playlistId,
              props.information.devices[0].itemSize
            );
          }
          props.information.displayNameVisibility === "On Hover" ||
          props.information.displayNameVisibility === "Show Always"
            ? setDesc(true)
            : setDesc(false);
          props.information.displayNameVisibility === "Show Always"
            ? setNews(true)
            : setNews(false);
          props.information.viewAllVisibility === true &&
          props.information.viewAllText !== null
            ? setViewlsAll(props.information.viewAllText)
            : setViewlsAll("");
          if (
            props.information.viewAllVisibility === true &&
            props.information.viewAllPage !== null
          ) {
            const link =
              props.information.viewAllPage.pageType === "externalPage"
                ? props.information.viewAllPage.externalPage
                : props.information.viewAllPage.pageType === "internalPage"
                ? "/" +
                  props.match.params.AppId +
                  "/" +
                  props.information.viewAllPage.internalPage
                : props.information.viewAllPage.urlName !== ""
                ? "/" +
                  props.match.params.AppId +
                  "/" +
                  props.information.viewAllPage.urlName
                : "/" +
                  props.match.params.AppId +
                  "/page/" +
                  props.information.viewAllPage._id;
            setviewlsLink(link);
          }
          isLoading(false);
        } else {
          if (
            props.tabid.playlistId !== null &&
            props.tabid.playlistId !== ""
          ) {
            playlistDetail(
              props.tabid.playlistId,
              props.tabid.devices[0].itemSize
            );
          }
          props.tabid.displayNameVisibility === "On Hover" ||
          props.tabid.displayNameVisibility === "Show Always"
            ? setDesc(true)
            : setDesc(false);
          props.tabid.displayNameVisibility === "Show Always"
            ? setNews(true)
            : setNews(false);
          props.tabid.viewAllVisibility === true &&
          props.tabid.viewAllText !== null
            ? setViewlsAll(props.tabid.viewAllText)
            : setViewlsAll("");
          if (
            props.tabid.viewAllVisibility === true &&
            props.tabid.viewAllPage !== null
          ) {
            const link =
              props.tabid.viewAllPage.pageType === "externalPage"
                ? props.tabid.viewAllPage.externalPage
                : props.tabid.viewAllPage.pageType === "internalPage"
                ? props.tabid.viewAllPage.internalPage
                : "/" +
                  props.match.params.AppId +
                  "/" +
                  props.tabid.viewAllPage.pageType +
                  "/" +
                  props.tabid.viewAllPage._id;
            setviewlsLink(link);
          }
          isLoading(false);
        }
      }
    };

    const playlistDetail = async (id, limit) => {
      /* eslint-disable no-unused-vars */
      if (Global.VCMS === "YouTube") {
        const result = await getYoutubePlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setLSPlaylist(result.data);
              isLoading(false);
            }
          },
          (error) => {
            isLoading(false);
          }
        );
      } else {
        const result = await getPlaylist(id, limit).then(
          (result) => {
            if (mounted.current) {
              setLSPlaylist(result.data);
              isLoading(false);
            }
          },
          (error) => {
            isLoading(false);
          }
        );
      }
      /* eslint-disable no-unused-vars */
    };

    ElemDetail();

    return () => {
      mounted.current = false;
    };
  }, [props.information, props.match.params.AppId, props.tabid, props.tabbed]);
  if (
    elemlsdisplay &&
    !error &&
    !loading &&
    (props.information || props.tabid)
  ) {
    return (
      <div className={Global.THBTD + " landscape"}>
        <SectionHeader
          title={lselem.displayName}
          linkTitle={viewlsAll}
          link={viewlsLink}
          header={props.header}
        ></SectionHeader>
        <div className="container-fluid ">
          <div className="col-sm-12 slider_container">
            <div className="slide-wrapper">
              <Swiper
                className="slide-slider-full swiper container"
                {...params}
                shouldSwiperUpdate
              >
                {lselemItem !== null ? (
                  lselemItem.map((item, index) =>
                    item.itemid.devices[0].itemVisibility ? (
                      <div key={index} className="slide-items">
                        <Anchor
                          className={
                            BORDER
                              ? "slide-one slide-two"
                              : "slide-one slide-two no-border"
                          }
                          to={
                            item.itemid.pageType === "externalPage"
                              ? item.itemid.externalPage
                              : item.itemid.pageType === "internalPage"
                              ? item.itemid.internalPage
                              : item.itemid.pageType === "videoPage"
                              ? "/" +
                                props.match.params.AppId +
                                "/" +
                                item.itemid.pageType +
                                "/" +
                                item.itemid.videoId
                              : item.itemid.urlName !== ""
                              ? "/" +
                                props.match.params.AppId +
                                "/" +
                                item.itemid.urlName
                              : item.itemid.pageType + "/" + item.itemid._id
                          }
                        >
                          <div
                            className={
                              BORDER ? "slide-image" : "slide-image no-border"
                            }
                          >
                            <LazyImg
                              src={
                                item.itemid.landscapeThumbnail
                                  ? getAWSUrl() +
                                    item.itemid.landscapeThumbnail.imagekey
                                  : ""
                              }
                              className={Global.RTL ? "" : "pos-abs"}
                              alt=""
                              orient="landscape"
                            />
                          </div>

                          {Global.THBTD === "BIM" ? (
                            <div
                              className={
                                desc && news
                                  ? "ms-exclusive-movie-content onshow"
                                  : desc && !news
                                  ? "ms-exclusive-movie-content onhover"
                                  : "ms-exclusive-movie-content onhide"
                              }
                            >
                              <div>
                                {item.itemid.displayName ? (
                                  <h4>
                                    {" "}
                                    {truncate(
                                      item.itemid.displayName,
                                      Global.YOUHEADCHAR
                                    )}{" "}
                                  </h4>
                                ) : (
                                  ""
                                )}
                                {item.itemid.displayName ? (
                                  <p>
                                    {truncate(
                                      item.itemid.description,
                                      Global.YOUPARACHAR
                                    )}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : Global.THBTD === "BIMWR" ? (
                            <div
                              className={
                                desc && news
                                  ? "ms-exclusive-movie-content onshow"
                                  : desc && !news
                                  ? "ms-exclusive-movie-content onhover"
                                  : "ms-exclusive-movie-content onhide"
                              }
                            >
                              <div>
                                {item.itemid.displayName ? (
                                  <h4>
                                    {" "}
                                    {truncate(
                                      item.itemid.displayName,
                                      Global.YOUHEADCHAR
                                    )}{" "}
                                  </h4>
                                ) : (
                                  ""
                                )}
                                {item.itemid.description ? (
                                  <p>
                                    {truncate(
                                      item.itemid.description,
                                      Global.YOUPARACHAR
                                    )}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>

                              <div className="ms-exclusive-rating">
                                <span className="play_button_icon">
                                  {/*  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                  >
                                    <path
                                      className="cls-1"
                                      d="M561.983,1176.56a0.347,0.347,0,0,0-.284-0.25l-3.72-.57-1.664-3.54a0.348,0.348,0,0,0-.63,0l-1.664,3.54-3.719.57a0.344,0.344,0,0,0-.284.25,0.365,0.365,0,0,0,.089.37l2.691,2.75-0.635,3.89a0.373,0.373,0,0,0,.14.36,0.32,0.32,0,0,0,.207.07,0.315,0.315,0,0,0,.163-0.04l3.327-1.84,3.327,1.84a0.355,0.355,0,0,0,.371-0.03,0.372,0.372,0,0,0,.139-0.36l-0.635-3.89,2.692-2.75A0.365,0.365,0,0,0,561.983,1176.56Z"
                                      transform="translate(-550 -1172)"
                                    ></path>
                                  </svg> */}
                                  <i className="fa fa-play"></i>
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div
                              className={
                                desc && news
                                  ? "slide-content showed"
                                  : desc && !news
                                  ? "slide-content"
                                  : "slide-content hidden"
                              }
                            >
                              <h2>
                                {truncate(
                                  item.itemid.displayName,
                                  Global.HEADCHAR
                                )}
                                {Global.FAVOURITES ? (
                                  <span
                                    className="span"
                                    onClick={(event) => {
                                      favourites(event, item.itemid, "page");
                                    }}
                                  >
                                    {" "}
                                    <i
                                      className={
                                        favourited(
                                          item.itemid._id,
                                          currentUser.FAVOURITES
                                        )
                                          ? "ri-check-fill"
                                          : "ri-add-line"
                                      }
                                    ></i>
                                  </span>
                                ) : (
                                  ""
                                )}
                              </h2>
                              <div>
                                <span className="tag">{item.rating}</span>
                                <span className="tag"></span>
                              </div>
                              {item.itemid.description ? (
                                <p>
                                  {truncate(
                                    item.itemid.description,
                                    Global.PARACHAR
                                  )}
                                </p>
                              ) : (
                                ""
                              )}
                            </div>
                          )}
                        </Anchor>
                      </div>
                    ) : (
                      <div
                        key={index}
                        className="none"
                        style={{ display: "none" }}
                      ></div>
                    )
                  )
                ) : (
                  <div className="slide-items">
                    <LazyImg
                      className="slide-items"
                      orient={"landscape"}
                    ></LazyImg>
                  </div>
                )}

                {Global.VCMS === "YouTube" ? (
                  lsplaylist.items !== undefined ? (
                    lsplaylist.items.map((item, index) => (
                      <div className="slide-items" key={index}>
                        <Link
                          className={
                            BORDER
                              ? "slide-one slide-two"
                              : "slide-one slide-two no-border"
                          }
                          to={
                            "/" +
                            props.match.params.AppId +
                            "/videoPage/" +
                            item.contentDetails.videoId
                          }
                        >
                          {/* {item.ContentType==="Premium"?<Icon></Icon>:""} */}
                          <div
                            className={
                              BORDER ? "slide-image" : "slide-image no-border"
                            }
                          >
                            <LazyImg
                              src={
                                "https://img.youtube.com/vi/" +
                                item.contentDetails.videoId +
                                "/mqdefault.jpg"
                              }
                              className={Global.RTL ? "" : "pos-abs"}
                              alt=""
                              orient="landscape"
                            />
                          </div>
                          {Global.THBTD === "BIM" ? (
                            <div
                              className={
                                desc && news
                                  ? "ms-exclusive-movie-content onshow"
                                  : desc && !news
                                  ? "ms-exclusive-movie-content onhover"
                                  : "ms-exclusive-movie-content onhide"
                              }
                            >
                              <div>
                                {item.snippet.title ? (
                                  <h4>
                                    {" "}
                                    {truncate(
                                      item.snippet.title,
                                      Global.YOUHEADCHAR
                                    )}{" "}
                                  </h4>
                                ) : (
                                  ""
                                )}
                                {item.snippet.description ? (
                                  <p>
                                    {truncate(
                                      item.snippet.description,
                                      Global.YOUPARACHAR
                                    )}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          ) : Global.THBTD === "BIMWR" ? (
                            <div
                              className={
                                desc && news
                                  ? "ms-exclusive-movie-content onshow"
                                  : desc && !news
                                  ? "ms-exclusive-movie-content onhover"
                                  : "ms-exclusive-movie-content onhide"
                              }
                            >
                              <div>
                                {item.snippet.title ? (
                                  <h4>
                                    {" "}
                                    {truncate(
                                      item.snippet.title,
                                      Global.YOUHEADCHAR
                                    )}{" "}
                                  </h4>
                                ) : (
                                  ""
                                )}
                                {item.snippet.description ? (
                                  <p>
                                    {truncate(
                                      item.snippet.description,
                                      Global.YOUPARACHAR
                                    )}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>

                              <div className="ms-exclusive-rating">
                                <span className="play_button_icon">
                                  {/*  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                  >
                                    <path
                                      className="cls-1"
                                      d="M561.983,1176.56a0.347,0.347,0,0,0-.284-0.25l-3.72-.57-1.664-3.54a0.348,0.348,0,0,0-.63,0l-1.664,3.54-3.719.57a0.344,0.344,0,0,0-.284.25,0.365,0.365,0,0,0,.089.37l2.691,2.75-0.635,3.89a0.373,0.373,0,0,0,.14.36,0.32,0.32,0,0,0,.207.07,0.315,0.315,0,0,0,.163-0.04l3.327-1.84,3.327,1.84a0.355,0.355,0,0,0,.371-0.03,0.372,0.372,0,0,0,.139-0.36l-0.635-3.89,2.692-2.75A0.365,0.365,0,0,0,561.983,1176.56Z"
                                      transform="translate(-550 -1172)"
                                    ></path>
                                  </svg> */}
                                  <i className="fa fa-play"></i>
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div
                              className={
                                desc && news
                                  ? "slide-content showed"
                                  : desc && !news
                                  ? "slide-content"
                                  : "slide-content hidden"
                              }
                            >
                              <h2>
                                {truncate(item.snippet.title, Global.HEADCHAR)}
                                {Global.FAVOURITES ? (
                                  <span
                                    className="span"
                                    onClick={(event) => {
                                      event.preventDefault();
                                      favourites(event, item, "video");
                                    }}
                                  >
                                    {" "}
                                    <i
                                      className={
                                        favourited(
                                          item.contentDetails.videoId,
                                          currentUser.FAVOURITES
                                        )
                                          ? "ri-check-fill"
                                          : "ri-add-line"
                                      }
                                    ></i>
                                  </span>
                                ) : (
                                  ""
                                )}
                              </h2>
                              <div>
                                <span className="tag">{""}</span>
                                <span className="tag">{""}</span>
                              </div>
                              {item.snippet.description ? (
                                <p>
                                  {truncate(
                                    item.snippet.description,
                                    Global.PARACHAR
                                  )}
                                </p>
                              ) : (
                                ""
                              )}
                            </div>
                          )}
                        </Link>
                      </div>
                    ))
                  ) : (
                    <div className="slide-items">
                      <LazyImg
                        className="slide-items"
                        orient={"landscape"}
                      ></LazyImg>
                    </div>
                  )
                ) : lsplaylist.playlist !== undefined ? (
                  lsplaylist.playlist.map((item, index) => (
                    <div className="slide-items" key={index}>
                      <Link
                        className={
                          BORDER
                            ? "slide-one slide-two"
                            : "slide-one slide-two no-border"
                        }
                        to={
                          "/" +
                          props.match.params.AppId +
                          "/videoPage/" +
                          item.mediaid
                        }
                      >
                        {item.ContentType === "Premium" ? <Icon></Icon> : ""}
                        <div
                          className={
                            BORDER ? "slide-image" : "slide-image no-border"
                          }
                        >
                          <LazyImg
                            src={item.images[0].src}
                            className={Global.RTL ? "" : "pos-abs"}
                            alt=""
                            orient="landscape"
                          />
                        </div>
                        {Global.THBTD === "BIM" ? (
                          <div
                            className={
                              desc && news
                                ? "ms-exclusive-movie-content onshow"
                                : desc && !news
                                ? "ms-exclusive-movie-content onhover"
                                : "ms-exclusive-movie-content onhide"
                            }
                          >
                            <div>
                              {item.title ? (
                                <h4>
                                  {" "}
                                  {truncate(
                                    item.title,
                                    Global.YOUHEADCHAR
                                  )}{" "}
                                </h4>
                              ) : (
                                ""
                              )}
                            </div>
                            {item.ShortDescription ? (
                              <p>
                                {truncate(
                                  item.ShortDescription,
                                  Global.YOUPARACHAR
                                )}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : Global.THBTD === "BIMWR" ? (
                          <div
                            className={
                              desc && news
                                ? "ms-exclusive-movie-content onshow"
                                : desc && !news
                                ? "ms-exclusive-movie-content onhover"
                                : "ms-exclusive-movie-content onhide"
                            }
                          >
                            <div>
                              {item.title ? (
                                <h4>
                                  {" "}
                                  {truncate(
                                    item.title,
                                    Global.YOUHEADCHAR
                                  )}{" "}
                                </h4>
                              ) : (
                                ""
                              )}
                            </div>
                            {item.ShortDescription ? (
                              <p>
                                {truncate(
                                  item.ShortDescription,
                                  Global.YOUPARACHAR
                                )}
                              </p>
                            ) : (
                              ""
                            )}
                            <div className="ms-exclusive-rating">
                              <span className="play_button_icon">
                                {/*  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                  >
                                    <path
                                      className="cls-1"
                                      d="M561.983,1176.56a0.347,0.347,0,0,0-.284-0.25l-3.72-.57-1.664-3.54a0.348,0.348,0,0,0-.63,0l-1.664,3.54-3.719.57a0.344,0.344,0,0,0-.284.25,0.365,0.365,0,0,0,.089.37l2.691,2.75-0.635,3.89a0.373,0.373,0,0,0,.14.36,0.32,0.32,0,0,0,.207.07,0.315,0.315,0,0,0,.163-0.04l3.327-1.84,3.327,1.84a0.355,0.355,0,0,0,.371-0.03,0.372,0.372,0,0,0,.139-0.36l-0.635-3.89,2.692-2.75A0.365,0.365,0,0,0,561.983,1176.56Z"
                                      transform="translate(-550 -1172)"
                                    ></path>
                                  </svg> */}
                                <i className="fa fa-play"></i>
                              </span>
                            </div>
                          </div>
                        ) : (
                          <div
                            className={
                              desc && news
                                ? "slide-content showed"
                                : desc && !news
                                ? "slide-content"
                                : "slide-content hidden"
                            }
                          >
                            {item.title ? (
                              <h2>
                                {truncate(item.title, Global.HEADCHAR)}
                                {Global.FAVOURITES ? (
                                  <span
                                    className="span"
                                    onClick={(event) => {
                                      favourites(event, item, "video");
                                    }}
                                  >
                                    {" "}
                                    <i
                                      className={
                                        favourited(
                                          item.mediaid,
                                          currentUser.FAVOURITES
                                        )
                                          ? "ri-check-fill"
                                          : "ri-add-line"
                                      }
                                    ></i>
                                  </span>
                                ) : (
                                  ""
                                )}
                              </h2>
                            ) : (
                              ""
                            )}
                            <div>
                              {item.VIdeoDuration ? (
                                <span className="tag">
                                  {item.VIdeoDuration}
                                </span>
                              ) : (
                                ""
                              )}
                              {item.PgRating ? (
                                <span className="tag">{item.PgRating}</span>
                              ) : (
                                ""
                              )}
                            </div>
                            {item.ShortDescription ? (
                              <p>
                                {truncate(
                                  item.ShortDescription,
                                  Global.PARACHAR
                                )}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        )}
                      </Link>
                    </div>
                  ))
                ) : (
                  <div className="slide-items">
                    <LazyImg
                      className="slide-items"
                      orient={"landscape"}
                    ></LazyImg>
                  </div>
                )}
              </Swiper>
              <div
                id={`arrows_${props.tabbed ? props.named : props.name}`}
                className={
                  props.tabbed
                    ? props.named + "prev swiper-arrows swiper-button-prev"
                    : props.name + "prev swiper-arrows swiper-button-prev"
                }
              />
              <div
                id={`arrows_${props.tabbed ? props.named : props.name}`}
                className={
                  props.tabbed
                    ? props.named + "next swiper-arrows swiper-button-next"
                    : props.name + "next swiper-arrows swiper-button-next"
                }
              />
            </div>
          </div>
        </div>
      </div>
    );
  } else if (elemlsdisplay && !error && loading) {
    return <div></div>;
  } else {
    return <div></div>;
  }
};

export default LandscapeSlider;
